<po-page-dynamic-search
  [p-actions]="pageActions"
  [p-filters]="searchFilters"
  [p-literals]="searchLiterals"
  p-concat-filters="true"
  (p-quick-search)="onQuickSearch($event)"
  (p-advanced-search)="onAdvancedSearch($event)"
  (p-change-disclaimers)="onChangeDisclaimers($event)"
>
  <po-table
    [p-columns]="areaColumns"
    [p-items]="areaRows"
    [p-actions]="areaActions"
    p-actions-right="true"
    p-striped="true"
    p-sort="true"
    p-spacing="small"
    [p-loading]="loading"
    [p-height]="tableFit.height"
    [p-literals]="{ noData: 'Nenhuma área encontrada' }"
  >
    <ng-template p-table-cell-template let-column="column" let-row="row">
      <ng-container *ngIf="column.property === 'tribeLabel'">
        <span *ngIf="row.tribeLabel">{{ row.tribeLabel }}</span>
        <span *ngIf="!row.tribeLabel" class="structure-muted">—</span>
      </ng-container>
      <ng-container *ngIf="column.property === 'usersCount'">
        <po-link *ngIf="row.usersCount" [p-label]="row.usersCount + ''" (p-action)="showUsers({ area: row.id })"></po-link>
        <span *ngIf="!row.usersCount">0</span>
      </ng-container>
    </ng-template>
  </po-table>
</po-page-dynamic-search>


<!-- Área -->
<po-modal
  #areaModal
  [p-title]="editingArea ? 'Editar área' : 'Nova área'"
  p-size="md"
  [p-primary-action]="areaPrimaryAction"
  [p-secondary-action]="areaCancel"
>
  <div class="po-row">
    <po-input
      class="po-sm-12"
      name="areaName"
      p-label="Nome da área"
      p-required
      [ngModel]="areaName"
      (ngModelChange)="areaName = $event ?? ''; validateAreaForm()"
    ></po-input>
    <p *ngIf="areaNameError" class="po-sm-12 structure-error">{{ areaNameError }}</p>
  </div>
  <div class="po-row structure-tribe-field" *ngIf="!creatingTribe">
    <po-select
      class="po-sm-12 po-md-8"
      name="areaTribe"
      p-label="Tribe"
      p-required
      p-placeholder="Escolha a tribe"
      [p-options]="tribeComboOptions"
      [ngModel]="areaTribeId"
      (ngModelChange)="areaTribeId = $event ?? ''; validateAreaForm()"
    ></po-select>
    <div class="po-sm-12 po-md-4 structure-tribe-new">
      <po-button p-kind="tertiary" p-icon="po-icon-plus" p-label="Nova tribe" (p-click)="openTribeForm()"></po-button>
    </div>
  </div>
  <div class="po-row structure-tribe-field" *ngIf="creatingTribe">
    <po-input
      class="po-sm-12 po-md-8"
      name="newTribeName"
      p-label="Nova tribe"
      p-placeholder="Nome da tribe"
      p-required
      [ngModel]="tribeName"
      (ngModelChange)="onTribeNameChange($event)"
      (keyup.enter)="saveTribe()"
    ></po-input>
    <div class="po-sm-12 po-md-4 structure-tribe-new structure-tribe-actions">
      <po-button p-kind="secondary" p-label="Criar" [p-disabled]="!canCreateTribe" [p-loading]="savingTribe" (p-click)="saveTribe()"></po-button>
      <po-button p-kind="tertiary" p-label="Cancelar" (p-click)="cancelTribeForm()"></po-button>
    </div>
    <p *ngIf="tribeNameError" class="po-sm-12 structure-error">{{ tribeNameError }}</p>
  </div>
  <po-info
    *ngIf="renamingArea"
    p-label="Ao salvar"
    [p-value]="'O nome muda de &quot;' + editingArea?.area + '&quot; para &quot;' + areaName.trim() + '&quot; em todo o ESP, inclusive nos recursos da área.'"
  ></po-info>
</po-modal>

<!-- Transferir / excluir área -->
<po-modal
  #transferModal
  [p-title]="transferTitle"
  p-size="md"
  [p-primary-action]="transferPrimaryAction"
  [p-secondary-action]="transferCancel"
>
  <ng-container *ngIf="transferArea">
    <po-stepper *ngIf="transferMode === 'delete'" p-orientation="horizontal" [p-steps]="transferSteps" [p-step]="1"></po-stepper>

    <p class="po-mb-2">
      A área tem <strong>{{ transferArea.usersCount }} usuário(s)</strong><ng-container *ngIf="transferReferences.length">
        e é usada por <strong>{{ transferReferences.join(", ") }}</strong></ng-container
      >.
      <ng-container *ngIf="transferMode === 'delete'">Escolha para onde eles vão antes de excluí-la.</ng-container>
      Os acessos dos usuários não mudam.
    </p>

    <po-combo
      name="transferTo"
      p-label="Área de destino"
      p-placeholder="Digite para buscar por área ou tribe"
      p-required
      p-field-label="label"
      p-field-value="value"
      [p-filter-service]="areaCombo"
      [(ngModel)]="transferToAreaId"
      [p-disabled]="transferring"
    >
      <ng-template p-combo-option-template let-option>
        <span>{{ option.label }}</span>
        <span class="area-combo-tribe">{{ option.tribeName }}</span>
      </ng-template>
    </po-combo>

    <po-radio-group
      *ngIf="transferMode === 'transfer' || transferArea.usersCount"
      name="transferWho"
      p-label="Quem transferir"
      [p-columns]="2"
      [p-options]="transferWhoOptions"
      [ngModel]="transferWho"
      (ngModelChange)="onTransferWhoChange($event)"
      [p-disabled]="transferring"
    ></po-radio-group>

    <p *ngIf="transferMode === 'delete'" class="structure-hint" [innerHTML]="historyWarning"></p>

    <p *ngIf="transferMode === 'delete' && transferWho === 'some'" class="structure-hint">
      Quem não for escolhido continua na área, e a exclusão fica bloqueada até a área ficar vazia.
    </p>

    <po-table
      *ngIf="transferWho === 'some'"
      p-selectable="true"
      p-hide-columns-manager="true"
      p-spacing="small"
      p-height="220"
      [p-items]="transferUsers"
      [p-columns]="transferUserColumns"
      [p-loading]="loadingTransferUsers"
      (p-selected)="onTransferUserSelected($event)"
      (p-unselected)="onTransferUserUnselected($event)"
      (p-all-selected)="onTransferAllSelected()"
      (p-all-unselected)="onTransferAllUnselected()"
    ></po-table>

    <div class="po-row po-mt-2" *ngIf="transferDestination">
      <po-info class="po-sm-12 po-md-4" p-label="Usuários" [p-value]="transferCount + ''"></po-info>
      <po-info
        class="po-sm-12 po-md-4"
        p-label="Tribe"
        [p-value]="(transferArea.tribeName || 'sem tribe') + ' → ' + (transferDestination.tribeName || 'sem tribe')"
      ></po-info>
      <po-info class="po-sm-12 po-md-4" p-label="Área" [p-value]="transferArea.area + ' → ' + transferDestination.area"></po-info>
    </div>
  </ng-container>
</po-modal>
